export type IconDef = { lib: 'mc' | 'fa5'; name: string };

export const PAYMENT_METHOD_ICONS: Record<string, IconDef> = {
  card: { lib: 'mc', name: 'credit-card-outline' },
  link: { lib: 'mc', name: 'link-variant' },
  us_bank_account: { lib: 'mc', name: 'bank-outline' },
  apple_pay: { lib: 'mc', name: 'apple' },
  google_pay: { lib: 'mc', name: 'google' },
  amazon_pay: { lib: 'fa5', name: 'amazon-pay' },
  paypal: { lib: 'fa5', name: 'paypal' },
};

export const getStatusColor = (status: string, theme: any) => {
  switch (status) {
    case 'active':
      return theme.colors.primary;
    case 'canceled':
    case 'past_due':
    case 'unpaid':
      return theme.colors.error;
    case 'trialing':
      return theme.colors.secondary || theme.colors.primary;
    default:
      return theme.colors.onSurfaceVariant;
  }
};

export const formatDate = (
  dateString: string,
  locale: string = 'pt-PT',
  options?: Intl.DateTimeFormatOptions
) => new Date(dateString).toLocaleDateString(locale, options).replace('.', '');

export const formatCurrency = (
  amount: number,
  currency: string,
  locale: string = 'pt-PT'
) => new Intl.NumberFormat(locale, { style: 'currency', currency: currency.toUpperCase() }).format(amount); 